import { render } from "./VehicleDeviations.vue?vue&type=template&id=c91aff0e"
import script from "./VehicleDeviations.vue?vue&type=script&lang=ts"
export * from "./VehicleDeviations.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn,QSpinner});
